/******/
(() => { // webpackBootstrap
  var __webpack_exports__ = {};
  window.PXUTheme.jsBannerHero = {
    init: function($section) {

      // Add settings from schema to current object
      window.PXUTheme.jsBannerHero = $.extend(this, window.PXUTheme.getSectionData($section));

      // Selectors
      const $videoElement = $section.find('[data-video-element]');
      const $playIcon = $section.find('.plyr--paused.plyr--video .plyr__control--overlaid');
      const $playButton = $section.find('[data-play-button]');
      const $videoTextContainer = $section.find('[data-video-text-container]');
      const $imageElement = $section.find('[data-image-element]');

      // Load video if the media has been added
      if (this.has_video) {
        this.heroBanner($('.video-element__wrap'));
      } else {
        $imageElement.show();
      }
  
      this.heroBanner($('.hero_banner'));
    },
    heroBanner: function($e) {
      this.resizeIframe($e);

      $(window).on('resize', () => {
        this.resizeIframe($e);
      });
    },
    resizeIframe: function($c) {
      let w = $c.width(),
        h = $c.height(),
        $f = $c.find('iframe'),
        ratio = $c.data('ratio') ? $c.data('ratio').split(':', 2)[0] / $c.data('ratio').split(':', 2)[1] : 16 / 9,
        frameAspect = 100 / ratio;

      $('.lazyframe').addClass('video_ratio').css({
        'padding-bottom': `${frameAspect}%`
      });
      if (h > w) {
        $f.css({
          'height': (h + 10),
          'width': ((h * frameAspect) + 10),
          'top': '0',
          'left': (w / 2) - ((h * frameAspect) / 2)
        });
      } else {
        $f.css({
          'height': ((w * frameAspect) + 10),
          'width': (w + 10),
          'top': (h / 2) - ((w * frameAspect) / 2),
          'left': '0'
        });
      }
    },
    unload: function($section) {
      const $playButton = $section.find('[data-play-button]');
      const $videoTextContainer = $section.find('[data-video-text-container]');

      $playButton.off();
      $videoTextContainer.off();
    }
  }

  /******/
})();